import { gql } from "@apollo/client";

export const GET_BUDGET_CATEGORIES = gql`
  query GetBudgetCategories($pId: ID!, $cId: ID!) {
    GetBudgetCategories(pId: $pId, cId: $cId) {
      bdgtCategory
      bdgtCostCode
    }
  }
`;
